import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
  ADD_CLASSNAME
} from "@/core/services/store/htmlclass.module";
import store from "@/core/services/store";

const HtmlClass = {
  config: null,

  init() {
    // init base layout
    this.initLayout();
    // init header and subheader menu
    this.initHeader();
    this.initSubheader();
    // init themes
    this.initThemes();
  },

  /**
   * Init Layout
   */
  initLayout() {
    // Offcanvas directions
    store.dispatch(ADD_BODY_CLASSNAME, "quick-panel-right");
    store.dispatch(ADD_BODY_CLASSNAME, "offcanvas-right");

    // Properly close mobile header menu
    store.dispatch(REMOVE_BODY_CLASSNAME, "header-menu-wrapper-on");
  },

  /**
   * Init Header
   */
  initHeader() {
    // Fixed header

    store.dispatch(ADD_BODY_CLASSNAME, "header-fixed");
    store.dispatch(ADD_CLASSNAME, {
      position: "header",
      className: "header-fixed"
    });

    store.dispatch(ADD_BODY_CLASSNAME, "header-mobile-fixed");
    store.dispatch(ADD_CLASSNAME, {
      position: "header_mobile",
      className: "header-mobile-fixed"
    });

    store.dispatch(ADD_CLASSNAME, {
      position: "header_menu",
      className: "header-menu-layout-default"
    });
  },

  /**
   * Init Subheader
   */
  initSubheader() {
    store.dispatch(ADD_BODY_CLASSNAME, "subheader-fixed");
    store.dispatch(ADD_BODY_CLASSNAME, "subheader-enabled");
    store.dispatch(ADD_BODY_CLASSNAME, "subheader-solid");
  },

  /**
   * Import theme SCSS file based on the selected theme
   */
  initThemes() {
    import("@/assets/sass/themes/layout/header/base/light.scss");
    import("@/assets/sass/themes/layout/header/menu/light.scss");
    import("@/assets/sass/themes/layout/brand/dark.scss");
  }
};

export default HtmlClass;
